import { IKBSection } from "../types";

export const flattenKBSections = (tree: IKBSection[]): IKBSection[] =>
  tree.flatMap((section) => [
    section,
    ...flattenKBSections(section.children ?? []),
  ]);

export const findKBArticleLocation = (
  tree: IKBSection[],
  docSlug: string,
): { sectionSlug: string; docSlug: string } | null => {
  for (const section of flattenKBSections(tree)) {
    const doc = (section.docs ?? []).find((item) => item.slug === docSlug);

    if (doc) {
      return { sectionSlug: section.slug, docSlug: doc.slug };
    }
  }

  return null;
};

export const hasKBArticle = (
  tree: IKBSection[],
  sectionSlug: string,
  docSlug: string,
): boolean =>
  flattenKBSections(tree).some(
    (section) =>
      section.slug === sectionSlug &&
      (section.docs ?? []).some((doc) => doc.slug === docSlug),
  );
